import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { Pages, toCommands } from '../../../constants/pages';
import { has } from '../../share/utils/has';


export const checkExistMembershipLevel: CanActivateChildFn = ({ queryParams }: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const hasMembershipLevelQueryParam = has(queryParams, 'membershiplevel');

  if (!hasMembershipLevelQueryParam) {
    router.navigate(toCommands(Pages.offers), { queryParams });

    return false;
  }

  return true;
};

export default checkExistMembershipLevel;
